import { Crm7Schedule } from "@/components/crm-demos/crm-7-schedule"
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_crm-demos/crm-7")({
  component: Crm7Page,
  head: () => ({ meta: [{ title: "CRM 7 · Schedule" }] }),
});

function Crm7Page() {
  return (
    <div className="flex w-full items-start justify-center p-10 md:p-20">
      <Crm7Schedule />
    </div>
  )
}
